import { render } from "./AddMilageCase.vue?vue&type=template&id=3bfdf5ea"
import script from "./AddMilageCase.vue?vue&type=script&lang=js"
export * from "./AddMilageCase.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/AddMilageCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bfdf5ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bfdf5ea', __exports__)) {
    console.log('reload')
    api.reload('3bfdf5ea', __exports__)
  }
  
  module.hot.accept("./AddMilageCase.vue?vue&type=template&id=3bfdf5ea", () => {
    console.log('re-render')
    api.rerender('3bfdf5ea', render)
  })

}


export default __exports__